import * as React from 'react';

function France(props) {
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", role: "presentation", focusable: "false", fill: "currentColor", viewBox: "0 0 16 16", className: "c-pieIcon c-pieIcon--france", width: "1em", height: "1em" }, props),
        React.createElement("path", { fill: "#EEE", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z" }),
        React.createElement("path", { fill: "#D80027", d: "M15 8a7 7 0 0 0-4.566-6.563v13.126A7 7 0 0 0 15 8Z" }),
        React.createElement("path", { fill: "#0052B4", d: "M1 8a7 7 0 0 0 4.566 6.563V1.437A7 7 0 0 0 1 8Z" })));
}

export { France as default };
